module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_landscape-67b71397ba033dac53474fab731780bb.png";